import CustomPopup from "@/Components/CustomPopup";
import { useGenerateApiKeyMutation } from "@/Store/APIs/ClientData.api";
import modalStyles from "@/Theme/modalsElements.module.scss";
import { throwNewToastSuccess } from "@/Utils/MainUtils";
import { Modal } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../Hooks/redux/useAppSelector";
import {
  BasicBlockContent,
  BasicBlockItem,
  BasicPageTitle,
  BasicPageWrapper,
} from "../../Theme/basicElements";
import BasicButton from "../../UI/BasicButton";
import ReadableBasicInput from "../../UI/ReadableBasicInput";
import UserCostsTable from "./Components/UserCostsTable";
import ChangePasswordModal from "./Modals/ChangePasswordModal";
import {
  ButtonWrapper,
  GeneratePopupBlock,
  InputButtonContainer,
  Link,
  LinkWrapper,
  ProfileBlockItem,
} from "./styled";

const MyProfilePage = () => {
  const navigate = useNavigate();

  const [generateKey] = useGenerateApiKeyMutation();

  const dataUser = useAppSelector((state) => state.clientDataSlice.user);

  const [apiKey, setApiKey] = useState<string | null>(null);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [openApiKeyPopup, setOpenApiKeyPopup] = useState(false);

  const popupRef = useRef<HTMLDivElement>(null);

  const handleAddMoney = () => {
    navigate("/finance");
  };

  // const getEncryptedId = (id: number) => {
  //   return btoa(String(id));
  // };

  const handleTogglePasswordModal = () => {
    setOpenPasswordModal(!openPasswordModal);
  };

  const handleOpenGenerateAPIKeyPopup = () => {
    setOpenApiKeyPopup((prev) => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setOpenApiKeyPopup(false);
    }
  };

  const handleGenerateApiKey = async () => {
    try {
      const res = await generateKey().unwrap();
      setApiKey(res.token);
      throwNewToastSuccess("API Key was created successfully");
      setOpenApiKeyPopup(false);
    } catch (err) {
      console.error("Ошибка при генерации API ключа", err);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <BasicPageWrapper>
      <BasicPageTitle>My profile</BasicPageTitle>
      <ProfileBlockItem style={{ gap: "59px" }}>
        <BasicBlockItem>Account name</BasicBlockItem>
        <BasicBlockContent>{dataUser?.name}</BasicBlockContent>
      </ProfileBlockItem>
      <ProfileBlockItem style={{ gap: "32px" }}>
        <BasicBlockItem>Change password</BasicBlockItem>
        <BasicButton
          onClick={handleTogglePasswordModal}
          size={"md"}
          text="Change"
          variant="blue"
          disabled={dataUser?.name?.includes("telegram")}
        ></BasicButton>
      </ProfileBlockItem>
      <ProfileBlockItem style={{ gap: "32px" }}>
        <ProfileBlockItem style={{ gap: "111px" }}>
          <BasicBlockItem>Balance</BasicBlockItem>
          <BasicPageTitle>$ {dataUser?.balance?.toFixed(2)}</BasicPageTitle>
        </ProfileBlockItem>
        <BasicButton
          onClick={handleAddMoney}
          size={"md"}
          text="Add"
          variant="blue"
        ></BasicButton>
      </ProfileBlockItem>
      <ProfileBlockItem style={{ gap: "130px", alignItems: "start" }}>
        <BasicBlockItem>Prices</BasicBlockItem>
        {dataUser && <UserCostsTable userInfo={dataUser} />}
      </ProfileBlockItem>
      {/* <ProfileBlockItem style={{ gap: "75px" }}>
        <BasicBlockItem>Referral Link</BasicBlockItem>
        <ReadableBasicInput
          inputValue={
            dataUser
              ? `${window.location.origin}/registration/${getEncryptedId(
                  dataUser?.id
                )}`
              : ""
          }
          size={"md"}
        />
      </ProfileBlockItem> */}
      <ProfileBlockItem style={{ gap: "90px" }}>
        <BasicBlockItem>API Key</BasicBlockItem>
        <InputButtonContainer>
          <ReadableBasicInput
            inputValue={apiKey || "●●●●●●●●●●●●●●●"}
            successMessage="API Key copied successfully"
            size={"md"}
            isCopyable={!!apiKey}
          />
          <ButtonWrapper>
            <BasicButton
              variant="blue"
              size="md"
              onClick={handleOpenGenerateAPIKeyPopup}
              text="Generate"
            />
            {openApiKeyPopup ? (
              <CustomPopup ref={popupRef}>
                <GeneratePopupBlock>
                  <span>Attention!</span>
                  <p>
                    The old token will stop working. The new one will be
                    displayed only once — make sure to save it in advance.
                  </p>
                  <BasicButton
                    size="sm"
                    text="Confirm"
                    variant="blue"
                    onClick={handleGenerateApiKey}
                  />
                </GeneratePopupBlock>
              </CustomPopup>
            ) : null}
          </ButtonWrapper>
          <LinkWrapper>
            <Link
              href="https://asofast.readme.io/reference/main"
              target="_blank"
              rel="noopener noreferrer"
            >
              Documentation
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M15 3h6v6" />
                <path d="M10 14 21 3" />
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
              </svg>
            </Link>
          </LinkWrapper>
        </InputButtonContainer>
      </ProfileBlockItem>
      <Modal
        open={openPasswordModal}
        onClose={handleTogglePasswordModal}
        className={modalStyles.modal}
      >
        <ChangePasswordModal handleClose={handleTogglePasswordModal} />
      </Modal>
    </BasicPageWrapper>
  );
};

export default MyProfilePage;
